import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import moment from 'moment';
import _cloneDeep from 'lodash/cloneDeep';

import AppDatePicker from '../../utilites/DateRangePicker/AppDatePicker';
import SearchLoader from '../Loader/SearchLoader';
import { useQuery, methodsSearchDeals, permissionsAccess, getUserFromLocalStorage, returnAnnuityDealType } from '../../../helpers/common';
import { Pagination, ShowItemsSelectPageCount } from '../../utilites';
import { getDealFacets, searchDeals } from '../../../redux/actions/searchAction';
import { ClientsAmountFilter, DealFilters } from '../Filters';
import './DealsearchResults.scss'
import '../search-results.scss';

import CrossSmallIcon from '../../../assets/icons/cross-small.svg';
import NothingFoundImage from '../../../assets/images/no_data.svg';
import {listRoles, pageOptions} from '../../../helpers/data-constants';
import {SESSION_BY_ID} from "../../../constants/token";
import { calculateTotalPages, getCurrentPage } from '../helpers';

const accent = new Set().add('Активен').add('Просрочен').add('На передаче').add('Удержание').add('Просрочен платеж');

const initialFilters = {
  term: '',
  branch: {},
  cashbox: {},
  purityName: {},
  purityType: {},
  dealType: {},
  status: {},
  carBrand: {},
  carDate: {},
  timeRange: { startDate: null, endDate: null },
  amountRange: [null, null],
  currentPage: 1,
  pageRange: pageOptions[0].value
};

const DealSearchResults = () => {
  const { isLoadingPageDealSearch, dealFacetData, dealSearchResults } = useSelector(
    ({ search }) => search,
  );
  const { accessFeatures } = useSelector(({ user }) => user);

  const userInfo = getUserFromLocalStorage();
  const goodSpecialist = (userInfo.roles.length === 1 && userInfo.roles.includes(listRoles.GOODS_SPECIALIST)) ||
    (userInfo.roles.length === 2 && userInfo.roles.includes(listRoles.GOODS_SPECIALIST && listRoles.LOYAL_GOODS_SPECIALIST));
  const userCashBox = JSON.parse(localStorage.getItem(SESSION_BY_ID))
  const query = useQuery();
  const history = useHistory();
  const queryTerm = useMemo(() => query.get('term'), [query]);
  
  const [filters, setFilters] = useState({
    ...initialFilters,
    term: queryTerm,
  });
  const [term, setTerm] = useState('');

  const dispatch = useDispatch();

  const theads = ['Вес, г.',
    'Статус договора', 'Тип договора', 'Срок предоставления займа',
    'Сумма микрозайма, руб.', 'Процент займа',
    'Процент неустойки', 'Сумма на выкуп, руб.'
  ]

  useEffect(() => {
    dispatch(getDealFacets(filters));
  }, [dispatch]);

  useEffect(() => {
    if (queryTerm && filters.term !== queryTerm) {
      const dataFilters = _cloneDeep(filters);
      dataFilters.term = queryTerm;
      dataFilters.currentPage = 1;
      setFilters(dataFilters);

      dispatch(searchDeals(methodsSearchDeals.buildRequest(dealFacetData, dataFilters)));
    }

  }, [queryTerm, filters, dispatch, dealFacetData]);

  const handleFilterChange = (filterName, newValue) => {
    setFilters((prev) => ({ ...prev, [filterName]: newValue }));
    const dataFilters = _cloneDeep(filters);

    if (newValue !== 'currentPage') {
      dataFilters.currentPage = 1;
    }

    dataFilters[filterName] = newValue;
    setFilters(dataFilters);

    dispatch(searchDeals(methodsSearchDeals.buildRequest(dealFacetData, dataFilters)));
  };

  const triggerSearchInput = (e) => {
    const newTerm = e.target.value;
    if (e.key === 'Enter') {
      e.target.blur();
      handleFilterChange('term', newTerm);
      history.replace({ term: '' });
    }
  };

  const onChange = (e) => {
    setTerm(e.target.value);
  };

  const resetTerm = () => {
    history.replace({ term: '' });
    handleFilterChange('term', '');
    setTerm('');
  };

  return (
    <>
      <div className="content-inner-data-columns">
        <div>
          {filters &&
            <>
              {
                permissionsAccess("elastic.facets.client.total") &&
                <div className='amount-facet'>
                  <ClientsAmountFilter onChange={(v) => handleFilterChange('amountRange', v)} /* reset={resetAmountFilter} *//>
                </div>
              }
              {
                permissionsAccess("elastic.facets.deal.cashbox") &&
                  <DealFilters
                      text="Подразделения"
                      values={filters.cashbox}
                      onChange={(v) => handleFilterChange('cashbox', v)}
                  />
              }
              {
                accessFeatures["branches"] && permissionsAccess("elastic.facets.deal.branch") &&
                  <DealFilters
                      text="Филиалы"
                      values={filters.branch}
                      onChange={(v) => handleFilterChange('branch', v)}
                  />
              }
              {
                  permissionsAccess("elastic.facets.deal.type") &&
                  <DealFilters
                      text="Тип договора"
                      values={filters.dealType}
                      onChange={(v) => handleFilterChange('dealType', v)}
                  />
              }
              {
                  accessFeatures["cars.feature"] && permissionsAccess("elastic.facets.deal.car_brand") &&
                  <DealFilters
                      text="Марка"
                      values={filters.carBrand}
                      onChange={(v) => handleFilterChange('carBrand', v)}
                  />
              }
              {
                  accessFeatures["cars.feature"] && permissionsAccess("elastic.facets.deal.car_date") &&
                  <DealFilters
                      text="Год выпуска"
                      values={filters.carDate}
                      onChange={(v) => handleFilterChange('carDate', v)}
                  />
              }
              {
                  permissionsAccess("elastic.facets.deal.purity_name") &&
                  <DealFilters
                      text="Пробы"
                      values={filters.purityName}
                      onChange={(v) => handleFilterChange('purityName', v)}
                  />
              }
              {
                  permissionsAccess("elastic.facets.deal.purity_type") &&
                  <DealFilters
                      text="Драг. металлы"
                      values={filters.purityType}
                      onChange={(v) => handleFilterChange('purityType', v)}
                  />
              }
              {
                  permissionsAccess("elastic.facets.deal.status") &&
                  <DealFilters
                      text="Статус"
                      values={filters.status}
                      onChange={(v) => handleFilterChange('status', v)}
                  />
              }
            </>
          }
        </div>
        <div className="content-inner-data-container">
          <div className="content-datatable">
            <div className="content-datatable-header ">
              <div className="d-flex flex-column align-center  fullwidth">
                <div className="content-datatable-header-actions d-flex flex-space-between">
                  <div className="content-datatable-header-search">
                    <input
                      className="input fullwidth"
                      type="text"
                      name="globalSearch"
                      id="globalSearch"
                      placeholder="Найти договор, залоговый билет, товар…"
                      autoComplete="off"
                      value={term}
                      onChange={onChange}
                      onKeyUp={triggerSearchInput}
                    />
                  </div>
                  <div className='d-flex'>
                    <AppDatePicker
                      coverClass="form-element"
                      startDate={filters.timeRange.startDate}
                      endDate={filters.timeRange.endDate}
                      onChange={(v) => handleFilterChange('timeRange', v)}
                    />
                    <ShowItemsSelectPageCount
                      options={pageOptions}
                      change={(v) => handleFilterChange('pageRange', parseInt(v))}
                      wrapClass='m-l-spacer-2'
                      statePageRange={filters.pageRange}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="content-datatable-content">
              <div className="search-facets">
                <div className="search-facets-pillboxes">
                  {filters.term && (
                    <button type="button" className="search-facet" onClick={resetTerm}>
                      <span className="not-crossed">{filters.term}</span>
                      <span className="icon">
                        <CrossSmallIcon />
                      </span>
                    </button>
                  )}
                  {(filters.timeRange.startDate || filters.timeRange.endDate) && (
                    <button
                      type="button"
                      className="search-facet"
                      onClick={() => {
                        handleFilterChange('timeRange', initialFilters.timeRange);
                      }}>
                      <span className="not-crossed">
                        Период: {methodsSearchDeals.toDisplayDate(filters.timeRange.startDate)} -{' '}
                        {methodsSearchDeals.toDisplayDate(filters.timeRange.endDate)}
                      </span>
                      <span className="icon">
                        <CrossSmallIcon />
                      </span>
                    </button>
                  )}
                  {dealFacetData &&
                      methodsSearchDeals
                          .getActiveFacets(dealFacetData.branch, filters.branch)
                          .map((facet) => (
                              <button
                                  key={facet}
                                  type="button"
                                  className="search-facet"
                                  onClick={() =>
                                      handleFilterChange('branch', {
                                        ...filters.branch,
                                        [facet]: false,
                                      })
                                  }>
                                <span className="not-crossed">{facet}</span>
                                <span className="icon">
                            <CrossSmallIcon />
                          </span>
                              </button>
                          ))}
                  {dealFacetData &&
                    methodsSearchDeals
                      .getActiveFacets(dealFacetData.cashbox, filters.cashbox)
                      .map((facet) => (
                        <button
                          key={facet}
                          type="button"
                          className="search-facet"
                          onClick={() =>
                            handleFilterChange('cashbox', {
                              ...filters.cashbox,
                              [facet]: false,
                            })
                          }>
                          <span className="not-crossed">{facet}</span>
                          <span className="icon">
                            <CrossSmallIcon />
                          </span>
                        </button>
                      ))}
                  {dealFacetData &&
                  methodsSearchDeals
                    .getActiveFacets(dealFacetData.carBrand, filters.carBrand)
                    .map((facet) => (
                      <button
                        key={facet}
                        type="button"
                        className="search-facet"
                        onClick={() =>
                          handleFilterChange('carBrand', {
                            ...filters.carBrand,
                            [facet]: false,
                          })
                        }>
                        <span className="not-crossed">{facet}</span>
                        <span className="icon">
                            <CrossSmallIcon />
                          </span>
                      </button>
                    ))}
                  {dealFacetData &&
                  methodsSearchDeals
                    .getActiveFacets(dealFacetData.carDate, filters.carDate)
                    .map((facet) => (
                      <button
                        key={facet}
                        type="button"
                        className="search-facet"
                        onClick={() =>
                          handleFilterChange('carDate', {
                            ...filters.carDate,
                            [facet]: false,
                          })
                        }>
                        <span className="not-crossed">{facet}</span>
                        <span className="icon">
                            <CrossSmallIcon />
                          </span>
                      </button>
                    ))}
                  {dealFacetData &&
                    methodsSearchDeals
                      .getActiveFacets(dealFacetData.purityName, filters.purityName)
                      .map((facet) => (
                        <button
                          key={facet}
                          type="button"
                          className="search-facet"
                          onClick={() =>
                            handleFilterChange('purityName', {
                              ...filters.purityName,
                              [facet]: false,
                            })
                          }>
                          <span className="not-crossed">{facet}</span>
                          <span className="icon">
                            <CrossSmallIcon />
                          </span>
                        </button>
                      ))}
                  {dealFacetData &&
                    methodsSearchDeals
                      .getActiveFacets(dealFacetData.purityType, filters.purityType)
                      .map((facet) => (
                        <button
                          key={facet}
                          type="button"
                          className="search-facet"
                          onClick={() =>
                            handleFilterChange('purityType', {
                              ...filters.purityType,
                              [facet]: false,
                            })
                          }>
                          <span className="not-crossed">{facet}</span>
                          <span className="icon">
                            <CrossSmallIcon />
                          </span>
                        </button>
                      ))}
                  {dealFacetData &&
                    methodsSearchDeals
                      .getActiveFacets(dealFacetData.dealType, filters.dealType)
                      .map((facet) => (
                        <button
                          key={facet}
                          type="button"
                          className="search-facet"
                          onClick={() =>
                            handleFilterChange('dealType', {
                              ...filters.dealType,
                              [facet]: false,
                            })
                          }>
                          <span className="not-crossed">{facet}</span>
                          <span className="icon">
                            <CrossSmallIcon />
                          </span>
                        </button>
                      ))}
                  {dealFacetData &&
                    methodsSearchDeals
                      .getActiveFacets(dealFacetData.status, filters.status)
                      .map((facet) => (
                        <button
                          key={facet}
                          type="button"
                          className="search-facet"
                          onClick={() =>
                            handleFilterChange('status', {
                              ...filters.status,
                              [facet]: false,
                            })
                          }>
                          <span className="not-crossed">{facet}</span>
                          <span className="icon">
                            <CrossSmallIcon />
                          </span>
                        </button>
                      ))}
                </div>
                {goodSpecialist &&
                  <button
                      type="button"
                      className="search-facet">
                <span className={'not-crossed'}>
                  {userCashBox?.label}
                </span>
                  </button>
                }
              </div>
              {isLoadingPageDealSearch ? (
                <SearchLoader />
              ) : (
                <table className="dealTable hover">
                  <thead>
                    <tr>
                      <th scope="col">
                        <p>Номер договора</p>
                      </th>
                      <th scope="col">
                        <p>Подразделение</p>
                      </th>
                      <th scope="col">
                        <p>Название, Марка</p>
                      </th>
                      <th scope="col">
                        <div className="dealTable-table-limitedWidth">
                            <p>IMEI, S\N, Модель,<br />Год выпуска</p>
                        </div>
                      </th>
                      <th scope="col">
                        <div className="dealTable-table-limitedWidth">
                            <p>Номер гос. регистрации, VIN номер</p>
                        </div>
                      </th>
                      {
                        theads.map((th, ind) => (
                          <th key={ind}>
                            {th}
                          </th>
                        ))
                      }
                    </tr>
                  </thead>
                  <tbody>
                    {dealSearchResults &&
                      dealSearchResults.deals.length !== 0 &&
                      dealSearchResults.deals.map((deal) => (
                        <tr
                          className={accent.has(deal.status) ? 'accent' : 'disabled'}
                          key={deal.id}>
                          <td>
                            <div className="dealTable-cellcontent">
                              <Link
                                href="#"
                                to={`/client/${deal.clientId}/contracts/${deal.id}`}
                                className="dealTable-link">
                                <span>{deal.dealNumber}</span>
                              </Link>
                            </div>
                          </td>
                          <td>
                            <p>
                              {(deal.cashBox && deal.cashBox[0] && deal.cashBox[0].name) || '-'}
                            </p>
                          </td>
                          <td>
                            <div className="dealTable-table-body-group">
                              {deal.name && deal.name.length !== 0 ? (
                                deal.name.map((i, ind) => (
                                  <div className="dealTable-table-body-box" key={i + ind}>
                                    <div className="dealTable-table-body-box-name">
                                      <p>{i}</p>
                                    </div>
                                  </div>
                                ))
                              ) : (
                                <div className="dealTable-table-body-box">
                                  <div className="dealTable-table-body-box-name">
                                    <p>-</p>
                                  </div>
                                </div>
                              )}
                            </div>
                          </td>
                          <td>
                            <div className="dealTable-table-body-group">
                              <div className="dealTable-table-body-box">
                                <div className="dealTable-table-body-box-name">
                                  <p>{(deal.things && deal.things.length !== 0 ) ? deal.things.filter(thing=>thing !== null && thing !== "").join(', ') : '-'}</p>
                                </div>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div className="dealTable-table-body-group">
                              <div className="dealTable-table-body-box">
                                <div className="dealTable-table-body-box-name">
                                  <p>{(deal.cars && deal.cars.length !== 0) ? deal.cars.join(', ') : '-'}</p>
                                </div>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div className="dealTable-table-body-group">
                              {deal.weight && deal.weight.length !== 0 ? (
                                deal.weight.map((i, ind) => (
                                  <div
                                    className="dealTable-table-body-box"
                                    key={'weight' + i + ind}>
                                     <div className="dealTable-table-body-box-weight">
                                      <p>{i}</p>
                                    </div>
                                  </div>
                                ))
                              ) : (
                                <div className="dealTable-table-body-box">
                                  <div className="dealTable-table-body-box-name">
                                    <p>-</p>
                                  </div>
                                </div>
                              )}
                            </div>
                          </td>
                          <td>
                            <p>
                              <nobr>{deal.status}</nobr>
                            </p>
                          </td>
                          <td>
                            <p>
                              <nobr>{deal.dealForm || '-'}</nobr>
                            </p>
                          </td>
                          <td>
                            <p>
                              {moment(deal.creationDate).format('DD.MM.yyyy')} — <br />
                              {moment(deal.endDate).format('DD.MM.yyyy')}
                            </p>
                          </td>
                          <td>
                            <p>{deal.amount.toFixed(2)}</p>
                          </td>
                          <td>
                            <p>{deal.basePercent.toFixed(2)}</p>
                          </td>
                          <td>
                            <p>{deal.delayPercent.toFixed(2)}</p>
                          </td>
                          <td>
                            <p>{deal.refundAmount.toFixed(2)}</p>
                          </td>
                        </tr>
                      ))}
                    {dealSearchResults && dealSearchResults.deals.length === 0 && (
                      <tr>
                        <td colSpan={4}>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}>
                            <div style={{ width: '60px' }}>
                              <NothingFoundImage />
                            </div>
                            <div style={{ marginLeft: '100px' }}>
                              По данному запросу ничего не найдено.
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
      {/*todo replace pagination with lazy load*/}
      <Pagination
        total={calculateTotalPages(dealSearchResults?.total, filters?.pageRange)}
        current={getCurrentPage(filters.currentPage, calculateTotalPages(dealSearchResults?.total, filters?.pageRange))}
        handlePageChange={(page) => handleFilterChange('currentPage', page)}
      />
    </>
  );
};

export default DealSearchResults;
